import { Box } from "@mui/joy";
import { useNavigate } from "react-router-dom";

import { useAuthentication } from "../../hooks/query";
import { useAuth } from "../../hooks";
import { useEffect } from "react";

export default function Logout() {
    const navigate = useNavigate();
    const { setIsAuthenticated, setUser, setRoles, setOrganizations, setToken } = useAuth();
    const { useLogout } = useAuthentication();
    const logoutSvc = useLogout();

    const fetchData = async () => {
        try {
            await logoutSvc.mutateAsync({});
            setUser(null);
            setRoles([]);
            setOrganizations([]);
            setToken("");
            setIsAuthenticated(false);
            navigate("/auth/landing");
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData().then();
    }, []);

    return <Box>Logging out...</Box>;
}
